import React from 'react';
import _ from 'lodash';
import './styles.scss';

interface Props {
  isValid?: boolean;
  label?: string;
  placeholder: string;
  value: string;
  onBlur?(value: string): void;
  onChange: any;
}

const Input: React.FC<Props> = ({
  label = '',
  placeholder,
  value,
  onBlur,
  onChange,
  isValid = true
}) => {
  const id = _.kebabCase(label);
  return (
    <div className="basic-input">
      {label !== '' && <label id={id}>{label}</label>}
      <input
        aria-labelledby={id}
        className={label !== '' ? 'with-label' : null}
        style={isValid ? null : { borderBottom: '1px solid #DC1F29' }}
        placeholder={placeholder}
        type="text"
        value={value}
        onBlur={event => onBlur && onBlur(event.target.value)}
        onChange={event => onChange(event.target.value)}
      />
    </div>
  );
};

export default Input;
